var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 1800 200",
    width: 1800,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 47L13.7 49C27.3 51 54.7 55 82 58.2C109.3 61.3 136.7 63.7 163.8 76.3C191 89 218 112 245.2 117.8C272.3 123.7 299.7 112.3 327 115.7C354.3 119 381.7 137 409 131.7C436.3 126.3 463.7 97.7 491 81.3C518.3 65 545.7 61 573 73.2C600.3 85.3 627.7 113.7 654.8 129.3C682 145 709 148 736.2 149.2C763.3 150.3 790.7 149.7 818 136.5C845.3 123.3 872.7 97.7 900 83C927.3 68.3 954.7 64.7 982 75C1009.3 85.3 1036.7 109.7 1063.8 112.5C1091 115.3 1118 96.7 1145.2 85.2C1172.3 73.7 1199.7 69.3 1227 69.5C1254.3 69.7 1281.7 74.3 1309 77.5C1336.3 80.7 1363.7 82.3 1391 78.8C1418.3 75.3 1445.7 66.7 1473 75.5C1500.3 84.3 1527.7 110.7 1554.8 121.5C1582 132.3 1609 127.7 1636.2 116C1663.3 104.3 1690.7 85.7 1718 81C1745.3 76.3 1772.7 85.7 1786.3 90.3L1800 95",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "miter",
    stroke: "#0051cc",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.14c4c11abec5da028f59b661cf5456d2.svg";
export { ForwardRef as ReactComponent };